/* http://youmightnotneedjquery.com/ */
var	doc = document,
    win = window,
    qS = function(query) { return document.querySelector(query); },
    qSA = function(query) { return document.querySelectorAll(query); },
    gE = function(query) { return document.getElementById(query); },
    body = doc.body,
    html = doc.documentElement,
    dataLayer = dataLayer ? dataLayer : [{}],
    isMobile = dataLayer[0].device == 'mobile',
    $d = {
		forEach : function(array, callback, scope) {
		  for (var i = 0; i < array.length; i++) {
		    callback.call(scope, array[i], i); // passes back stuff we need
		  }
		},
		domLoad : function(fn) {
			if (document.readyState == 'complete'){
			  fn();
			} else {
			  window.addEventListener('load', fn, true);
			}
		},
		/* Dom manipulation */
		prepend : function(source, parent) {
			if (!(parent instanceof Element)) return;
			if (source instanceof Element)
				parent.insertBefore(source, parent.firstChild);
			else if (typeof source === "string") {
				parent.insertAdjacentHTML('afterbegin', source);
			}
		},
		append : function(source, parent) {
			if (!(parent instanceof Element)) return;
			if (source instanceof Element)
				parent.appendChild(source);
			else if (typeof source === "string") {
				parent.insertAdjacentHTML('beforeend', source);
			}
		},
		before : function(source, target) {
			if (!(target instanceof Element)) return;
			if (source instanceof Element)
				target.parentNode.insertBefore(source, target);
			else if (typeof source === "string")
				target.insertAdjacentHTML('beforebegin', source);
		},
		after : function(source, target) {
			if (!(target instanceof Element)) return;
			if (source instanceof Element) {
				var parent = target.parentNode;
		  	if (target !== parent.lastElementChild) {
					parent.insertBefore(source, target.nextElementSibling);
				} else {
					parent.appendChild(source, parent);
				}
			} else if (typeof source === "string") {
				target.insertAdjacentHTML('afterend', source);
			}
		},
		next : function(el) {
			if (!(el instanceof Element)) return;
			return el.nextElementSibling;
		},
		prev : function(el) {
			if (!(el instanceof Element)) return;
			return el.previousElementSibling;
		},
		parents: function(el, selector) {
		    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
		    while (el) {
		        if (matchesSelector.call(el, selector)) break;
		        el = el.parentElement;
		    }
		    return el;
		},
		create : function(tag, cls, html) {
		  var ele = document.createElement(tag);
		  if (cls) ele.className = cls;
		  if (html) ele.innerHTML = html;
		  return ele;
		},

		show : function(el) {
			if (!(el instanceof Element)) return;
			el.style.display = 'block';  
		},
		hide : function(el, delay) {
			if (!(el instanceof Element)) return;
		 	if (!delay) delay = 0;
		 	window.setTimeout( function() {  el.style.display = 'none'; }, delay*1000);  
		},
		fadeOut : function(el, duration, delay) {
			if (!(el instanceof Element)) return;
			if (!el.style.display || el.style.display == 'none') return;
			if (!duration) duration = 1;
			if (!delay) delay = 0;
			el.style.opacity = 1;
			el.style.transition = 'opacity ' + duration + 's';
			window.setTimeout( function() {  el.style.opacity = 0; }, delay*1000);
			window.setTimeout( function() {  el.style.display = 'none'; }, (delay+duration)*1000);
		},
		fadeIn : function(el, duration, delay) {
			if (!(el instanceof Element)) return;
			if (el.style.display && el.style.display != 'none') return;
			if (!duration) duration = 1;
			if (!delay) delay = 0;
			el.style.opacity = 0;
			el.style.display = 'block';
			el.style.transition = 'opacity '+duration+'s';
			window.setTimeout( function() {  el.style.opacity = 1; }, delay*1000);
		},
		scrollto : function(config) {
			// distance, toElement, duration, callback, root, onlyUp
			config.duration = config.duration === undefined ? 400 : config.duration;
			config.root = config.root || window;
			var distance = config.distance || 0;
		    function doScroll(to, duration) {
		    	setTimeout(function(){  config.root.scrollTo(0, to); }, duration);
		    }
			var moving_frequency = 16,
			    hop_count = (config.duration - (config.duration % moving_frequency)) / moving_frequency,
			    getScrollTopDocumentAtBegin = config.root == window ? (document.documentElement.scrollTop + document.body.scrollTop) : config.root.scrollTop,
			    hop_top_position,
			    easeInOutQuad,
			    percentage;

			if (config.toElement && typeof config.toElement == "object") {
				distance += config.toElement.getBoundingClientRect().top;
			}
			if (config.onlyUp && distance > 0) return;
			percentage = 0;
			for(var i = 1; i <= hop_count; i++) {
				percentage = (i/hop_count);
				percentage = (percentage > 1) ? 1 : percentage;
				easeInOutQuad = percentage < 0.5 ? 2 * percentage * percentage : - 1 + (4 - 2 * percentage) * percentage;
				hop_top_position = getScrollTopDocumentAtBegin + ( distance * easeInOutQuad );
				doScroll(hop_top_position, moving_frequency*i);
			}
			if (!config.duration) {
				doScroll(getScrollTopDocumentAtBegin + distance, 0);
			}
			if (config.callback) {
				setTimeout(config.callback, moving_frequency*hop_count);
			}

		},
	    throttle : function(callback, limit) {
		    var wait = false;                  // Initially, we're not waiting
		    return function () {               // We return a throttled function
		        if (!wait) {                   // If we're not waiting
		            callback.call();           // Execute users function
		            wait = true;               // Prevent future invocations
		            setTimeout(function () {   // After a period of time
		                wait = false;          // And allow future invocations
		            }, limit);
		        }
		    };
		},

	};